import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { loginUser } from "../api";

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const data = await loginUser(username, password);
            const roles = Array.isArray(data.roles) ? data.roles : data.roles ? [data.roles] : [];
            login(data.token, roles, data.userId);
            let destination = "/work-orders";
            if (roles.includes("ADMIN")) {
                destination = "/admin/users";
            } else if (roles.includes("LAGERIST")) {
                destination = "/inventory";
            } else if (roles.includes("DISPONENT")) {
                destination = "/work-orders";
            }
            navigate(destination);
        } catch {
            setError("Login fehlgeschlagen");
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-80">
                <h2 className="text-xl font-bold mb-4">Login</h2>
                {error && <div className="mb-2 text-red-600">{error}</div>}
                <input
                    type="text"
                    placeholder="Benutzername"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full mb-3 p-2 border rounded"
                />
                <input
                    type="password"
                    placeholder="Passwort"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full mb-3 p-2 border rounded"
                />
                <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded">
                    Login
                </button>

            </form>
        </div>
    );
}


export default Login;

